import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";
import Image from "next/image";

type TFeaturedNewsCardProps = {
	title: string;
	href: string;
	imageUrl: string;
};

const FeaturedNewsCard = ({ title, href, imageUrl }: TFeaturedNewsCardProps) => {
	const { isLoggedIn } = useAuth();

	const { openModal } = useModal();
	const handleOnClick = () => {
		if (isLoggedIn) {
			window.open(href, "_blank");
		} else {
			openModal(ModalType.Auth);
		}
	};
	return (
		<article className="flex flex-col items-start justify-start overflow-hidden rounded-2xl border transition-all duration-150 ease-linear hover:shadow-xl">
			<div className="relative w-full">
				<Image
					src={imageUrl}
					alt="Image"
					width={1080}
					height={1080}
					className="h-36 w-full bg-gray-100 object-cover"
				/>
			</div>

			<div className="mb-3 h-full w-full">
				<div className="flex items-start p-2 ">
					<div className="group relative">
						<h3 className="mt-4 text-lg font-semibold leading-6 text-gray-900 group-hover:text-brand-primary">
							<button onClick={handleOnClick} className="block text-left">
								<span className="absolute inset-0" />
								{title}
							</button>
						</h3>
					</div>
				</div>
			</div>
		</article>
	);
};

export default FeaturedNewsCard;
